import { motion } from "framer-motion";
import { Heart } from "lucide-react";

// Four-point twinkle star
export const Sparkle = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} fill="currentColor" aria-hidden>
    <path d="M12 0c.55 5.7 6.3 11.45 12 12-5.7.55-11.45 6.3-12 12-.55-5.7-6.3-11.45-12-12C5.7 11.45 11.45 5.7 12 0z" />
  </svg>
);

// Hand-drawn underline squiggle for accent words
export const Squiggle = ({ className = "" }) => (
  <svg viewBox="0 0 200 14" className={className} fill="none" preserveAspectRatio="none" aria-hidden>
    <path d="M3 9C42 2 64 2 102 7s60 4 95-3" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);

// Soft blurred blush blob
export const Blush = ({ className = "", color = "#E8D3A6", size = "26rem", style }) => (
  <span className={`blush ${className}`} style={{ width: size, height: size, background: color, opacity: 0.35, ...style }} aria-hidden />
);

// Gently floating SVG sparkles & hearts layered behind content (emoji-free)
const SPOTS = [
  { type: "sparkle", top: "9%", left: "6%", cls: "h-7 w-7 text-[#F4B999]", a: "animate-floaty", d: "0s" },
  { type: "heart", top: "17%", right: "9%", cls: "h-5 w-5 text-[#D2B67E]", a: "animate-floatyX", d: "0.4s" },
  { type: "heart", top: "63%", left: "4%", cls: "h-4 w-4 text-[#F4B999]", a: "animate-floaty", d: "1.1s" },
  { type: "sparkle", top: "73%", right: "7%", cls: "h-6 w-6 text-[#FBC4A8]", a: "animate-floatyX", d: "0.8s" },
  { type: "sparkle", top: "44%", right: "4%", cls: "h-4 w-4 text-[#F4B999]", a: "animate-twinkle", d: "0.2s" },
];

export const FloatingDecor = ({ className = "" }) => (
  <div className={`pointer-events-none absolute inset-0 z-0 overflow-hidden ${className}`} aria-hidden>
    {SPOTS.map((p, i) => (
      <span key={i} className={`absolute ${p.a}`} style={{ top: p.top, left: p.left, right: p.right, animationDelay: p.d }}>
        {p.type === "sparkle"
          ? <Sparkle className={p.cls} />
          : <Heart className={`${p.cls} fill-current`} />}
      </span>
    ))}
  </div>
);

// A small animated badge that pulses, e.g. "✨ Loved by 1,000+ girls"
export const PulseBadge = ({ children, className = "", testid }) => (
  <motion.span
    data-testid={testid}
    initial={{ scale: 0.9, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className={`inline-flex items-center gap-2 rounded-full border border-[#F6D8C2] bg-white/70 px-4 py-1.5 text-xs font-medium text-[#FBC4A8] backdrop-blur ${className}`}
  >
    {children}
  </motion.span>
);
